import { jwtDecode } from 'jwt-decode';
import { React, useContext, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Col, Row } from 'reactstrap';
import { AuthContext } from '../../context/authContext';
import HeadquarterInput from './HeadquarterInput';
import HeadquartersData from './HeadquartersData';
import ModalSesion from '../../layouts/modal/ModalSession';

const LoginForm = () => {
  const headquarters = HeadquartersData;
  const { loginGoogle, userError, setUserError } = useContext(AuthContext);
  const [empresaId, setEmpresaId] = useState('CEDESCA');

  const handleSuccess = async (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);
    const profileObj = {
      email: decoded.email,
      name: decoded.name,
      imageUrl: decoded.picture,
    };
    await loginGoogle({
      tokenId: credentialResponse.credential,
      profileObj,
      empresaId,
    });
  };

  const handleError = () => {
    setUserError(true);
  };

  const onChangeRadioValue = (e) => {
    setEmpresaId(e.target.value);
  };

  return (
    <form>
      {userError === true ? (
        <ModalSesion
          isOpen={userError}
          setIsOpen={setUserError}
          body="Usuario no encontrado."
          header="Algo ha salido mal"
        />
      ) : (
        ''
      )}
      <Row>
        {headquarters.map((headquarter) => (
          <Col key={headquarter.name}>
            <HeadquarterInput
              key={headquarter.name}
              headquarter={headquarter.name}
              imgUrl={headquarter.url}
              onChange={onChangeRadioValue}
            />
          </Col>
        ))}
      </Row>
      <Row className="mt-4">
        <div className="m-auto w-75 d-flex justify-content-center">
          <GoogleLogin onSuccess={handleSuccess} onError={handleError} useOneTap />
        </div>
      </Row>
    </form>
  );
};
export default LoginForm;
